export const COLLECT_USER_STATISTIC = process.env.REACT_APP_COLLECT_USER_STATISTIC;
const YANDEX_METRIC_ID_PROD = 33220413;
const YANDEX_METRIC_ID_DEV = 50931395;

export const YANDEX_METRIC_ID = COLLECT_USER_STATISTIC === 'prod'
  ? YANDEX_METRIC_ID_PROD
  : YANDEX_METRIC_ID_DEV

export const USE_YA = COLLECT_USER_STATISTIC === 'prod' || COLLECT_USER_STATISTIC === 'dev';

export const YANDEX_METRIKA_SCRIPT = (() => {
  return `
   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
   m[i].l=1*new Date();
   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
   (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
   ym(56757502, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true,
        ecommerce:"dataLayer"
   });
`;
})();